module.exports = __webpack_public_path__ + "media/images/categories/color/hand-1a80b08d019010fbae97066c9277289d.png";